import { gql, useQuery } from '@apollo/client';
import { client } from '../../../apollo';
import { GET_USERS } from '../../../apollo/queries/users.auth.graphql';
import { useCreate, useUpdate } from '../../../utils/useUpdateCreate';
import {
  CreateUserMutation,
  GetUserQuery,
  GetUserQueryVariables,
  UpdateUserMutation,
  UserCreationInput,
  UserUpdateInput,
} from '../../../__generated__/queries-auth';

export const GET_USER = gql`
  query GetUser($where: UserUniqueFilterInput!) {
    user(where: $where) {
      id
      name
      createdAt
      email
      avatarUrl
      roles
    }
  }
`;

export const useGetUser = (id?: string, skip?: boolean) =>
  useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    variables: { where: { id } },
    skip: !id || skip,
  });

export const UPDATE_USER = gql`
  mutation UpdateUser($where: UserUniqueFilterInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      id
    }
  }
`;

export const useUpdateUser = () =>
  useUpdate<UpdateUserMutation, UserUpdateInput>(UPDATE_USER, [GET_USER]);

export const CREATE_USER = gql`
  mutation CreateUser($data: UserCreationInput!) {
    createUser(data: $data) {
      id
    }
  }
`;

export const useCreateUser = () =>
  useCreate<CreateUserMutation, UserCreationInput>(CREATE_USER, [GET_USERS]);

export const getUser = async (id: string) => {
  const { data, errors } = await client.query<
    GetUserQuery,
    GetUserQueryVariables
  >({
    query: GET_USER,
    variables: { where: { id } },
  });

  if (errors?.length) {
    throw errors[0];
  }
  return data?.user;
};
